import type { ApiResponse, ListResult } from "~/types";
import type { ConfirmOrderResult, OmsOrderDetail, OrderGeneratedResult, OrderParam } from "~/types/ConfirmOrder";
import type { NitroFetchRequest, $Fetch } from 'nitropack'
export const orderRepository = () => ({
    async generateConfirmOrder(cartIds: number[]) {
        return await useAPIFetch<ApiResponse<ConfirmOrderResult>>('/order/generateConfirmOrder', {
            method: 'POST',
            body: cartIds, // Using body: data
        });
    },

    async generateOrder(orderParam: OrderParam) {
        return await useAPIFetch<ApiResponse<OrderGeneratedResult>>('/order/generateOrder', {
            method: 'POST',
            body: orderParam, // Using body: data
        });
    },

    async fetchOrderList(pageNum: number, pageSize: number, status?: number) {
        return await useAPI<ApiResponse<ListResult<OmsOrderDetail>>>('/order/list', {
            params: { pageNum, pageSize, status }, // Query parameters
            // watch:true
        });
    },

    async payOrderSuccess(orderId: number, payType: number) {
        return await useAPIFetch<ApiResponse<number>>('/order/paySuccess', {
            method: 'POST',
            params: { orderId, payType }, // Query parameters
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' },
        });
    },

    async fetchOrderDetail(orderId: string) {
        return await useAPIFetch<ApiResponse<OmsOrderDetail>>(`/order/detail/${orderId}`, {
            method: 'GET',
        });
    },

    async cancelUserOrder(orderId: number) {
        return await useAPIFetch<ApiResponse<null>>('/order/cancelUserOrder', {
            method: 'POST',
            params: { orderId }, // Query parameter
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' },
        });
    },

    async confirmReceiveOrder(orderId: number) {
        return await useAPIFetch<ApiResponse<null>>('/order/confirmReceiveOrder', {
            method: 'POST',
            params: { orderId }, // Query parameter
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' },
        });
    },

    async deleteUserOrder(orderId: number) {
        return await useAPIFetch<ApiResponse<null>>('/order/deleteOrder', {
            method: 'POST',
            params: { orderId }, // Query parameter
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' },
        });
    },
});
